import { IconBox, LightningBoltIcon } from "@hightouch/htui";
import { SchemaIconProps } from "./types";

export const LightningIcon = ({ size = "xl", ...props }: SchemaIconProps) => {
  return (
    <IconBox color="teal" icon={<LightningBoltIcon />} size={size} {...props} />
  );
};
